import React, { Component } from 'react';

import './HomePage.scss';

import AOS from 'aos';

import 'aos/dist/aos.css';

import SplashSVG from '../../../images/homePage/splash';

import aboutImg from '../../../images/homePage/chart.jpg';

import Automated from '../../../images/homePage/automated';

import Cash from '../../../images/homePage/cash';

import DoubleCheck from '../../../images/homePage/doubleCheck';

import TickSVG from '../../../images/homePage/tick';

import Signup from 'Demora/../app/NoAuth/Signup';

import { Link, withRouter } from 'react-router-dom';

import classnames from 'classnames';

import SalesTicker from './Sales/sales-ticker';

class HomePage extends Component {
	constructor() {
		super();

		this.state = {
			learnMore: false,
			showVideo: false,
		};

		this.aboutRef = React.createRef();
	}

	componentDidMount() {
		AOS.init({
			duration: 800,
			easing: 'ease-in-out',
			once: true,
		});

		const bodyel = document.body;

		bodyel.style.background = '#eee';

		window.addEventListener('scroll', this.scrollto);
	}

	componentWillUnmount() {
		document.body.style.background = 'initial';
		this.removeEventListener();
	}

	removeEventListener = () => {
		window.removeEventListener('scroll', this.scrollto);
	};

	hideVideo = () => {
		this.setState({
			showVideo: false,
		});
	};

	revealVideo = () => {
		this.setState({
			showVideo: true,
		});
	};

	scrollto = () => {
		console.log(11);

		this.setState(
			{
				learnMore: true,
			},
			() => {
				setTimeout(() => {
					console.log(12);

					this.aboutRef.current.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'nearest',
					});
				}, 150);
			},
		);
		this.removeEventListener();
	};

	render() {
		const { showVideo, learnMore } = this.state;

		const boxes = [
			{
				title: 'Earn Money',
				/*
				subtitle: (
					<div>
						Do you know how effective your advertising is?{' '}
						<span className='yellow-highlight'>Stop wasting your time</span> and
						get "Real Time Live" stats!'
					</div>
				),
*/
				svg: Cash,
				benefits: [
					<span>
						<span className='yellow-highlight bg-danger'>
							3 WAYS TO EARN MONEY
						</span>
					</span>,
					'Weekly Cash Payouts',
					'Build A List Of Followers',
				],
				/*
				description: (
					<div>
						Use z5 Traffic and discover everything you didn't know about
						what's been happening with the advertising you use.
						<div className='alert alert-info'>
							<b>Definition:</b> Link tracking is when you track the number of
							clicks obtained by specific links on your website, in your emails,
							or even your social media posts.
							<br />
							<br />
							Link tracking can also be used to track if people are clicking on
							links associated with your banner advertisements.
						</div>
						z5 Traffic is a stats service, a short link service, a rotator and
						an advertising resource all rolled into one.
					</div>
				),
*/
			},
			{
				title: 'Easy to setup',
				/*
				subtitle: (
					<div>
						<span className='yellow-highlight'>Increase your conversion</span>{' '}
						by using your own custom splash pages! It's so simple to get
						started!
					</div>
				),
*/
				svg: Automated,
				benefits: [
					'Everything Is Setup For You (15 minutes)',
					'No Customers To Deal With',
					'Commission Paid Out Weekly',
				],
				/*
				description: (
					<div>
						One thing that everyone in our industry agrees on, is the use of
						splash pages (landing pages) to promote your affiliate links.
						<div className='alert alert-info'>
							<b>Definition:</b> In digital marketing, a landing page is a
							standalone web page, created specifically for a marketing or
							advertising campaign. It’s where a visitor “lands” after they
							click on a link in an email, or ads from Google, Bing, YouTube,
							Facebook, Instagram, Twitter, or similar places on the web.
						</div>
						We make it really easy to create your own splash pages in seconds.
						You design, we host, you benefit!
					</div>
				),
*/
			},
		];

		return (
			<div className='d-flex' id='hero1'>
				<div id='hero2'>
					<section id='hero3' className='d-flex'>
						<div
							className='hero-container maxHomePageWidth flex-grow-1 pl-2 pr-2'
							data-aos='fade-up'
						>
							<div className='row hero-benefits text-center'>
								<div className='col'>
									<h1 className='text-light'>
										<div
											className='bg-warning text-dark text-center mx-auto p-4 mt-5 mb-3'
											style={{ borderRadius: '40px', maxWidth: '800px' }}
										>
											Fed up with not earning money online?
										</div>
										<div
											className='bg-warning text-dark text-center mx-auto p-4'
											style={{ borderRadius: '40px', maxWidth: '800px' }}
										>
											Earn $10, $100 or $1,000 a month, it's up to you!
										</div>
									</h1>
								</div>
							</div>
							<div
								className='d-flex justify-content-center h2'
								style={{ marginBottom: '50px' }}
							>
								<button
									href='#about'
									className='btn-get-started scrollto text-center'
									onClick={this.scrollto}
								>
									Get Started
									<br />
									for FREE
								</button>
							</div>
						</div>
						<div className='sticky_ticker_container' style={{ zIndex: 100 }}>
							<SalesTicker />
						</div>
					</section>

					<div ref={this.aboutRef}>
						{learnMore && (
							<main id='main' className='maxHomePageWidth'>
								<section id='about' className='about'>
									<div className='about-container' data-aos='fade-up'>
										<h1
											className='text-light text-center bg-primary p-4 border'
											style={{ borderRadius: '40px' }}
										>
											<div className='mb-3'>
												You need Our{' '}
												<strong>
													Simple{' '}
													<u
														className='font-italic'
														style={{ color: 'rgb(255, 255, 165)' }}
													>
														EASY TO SETUP
													</u>
												</strong>{' '}
												System... that uses the <b>NEW</b> method of making
												money online!
											</div>
											<div className='row mb-3'>
												{['Advertise', 'Connect', 'Convert'].map(w => {
													return (
														<div className='col-12 col-md-4 mt-3' key={w}>
															<div className='bg-warning text-dark border border-white p-4'>
																{w}
															</div>
														</div>
													);
												})}
											</div>
										</h1>

										<div className='row justify-content-end'>
											<div className='col-lg-12'>
												<div className='row justify-content-end p-2'>
													{boxes.slice(0, 2).map((Box, i) => {
														return (
															<div key={i} className='col-benefit mb-4'>
																<div className='card shadow-sm border-primary h-100'>
																	<div className='card-header d-flex'>
																		<Box.svg
																			style={{
																				height: '25px',
																				width: '25px',
																				marginRight: '8px',
																			}}
																			fill='#ffffff'
																		/>
																		<h4 className='my-0 fw-normal'>
																			{Box.title}
																		</h4>
																	</div>
																	<div className='card-body p-3'>
																		<ul
																			className='list-unstyled m-0'
																			style={{
																				lineHeight: '1.3rem',
																			}}
																		>
																			{Box.benefits.map((ben, i) => {
																				return (
																					<li key={i} className='mb-2'>
																						<TickSVG
																							color='#008000'
																							style={{
																								height: '22px',
																								marginRight: '8px',
																							}}
																						/>
																						{ben}
																					</li>
																				);
																			})}
																		</ul>
																	</div>
																</div>
															</div>
														);
													})}
												</div>
											</div>
										</div>

										<h1
											className='p-4 text-center alert alert-warning border border-danger text-danger'
											style={{
												fontFamily: 'impact',
												marginBottom: '25px',
												borderWidth: '5px!important',
											}}
										>
											<u>
												Build Your Own{' '}
												<span className='yellow-highlight'>Money Making</span>{' '}
												Following
											</u>
										</h1>

										<div className='row bg-white'>
											<div className='col-lg-6 content'>
												<h4
													className='text-left alert alert-warning text-danger'
													style={{ margin: '0 -15px' }}
												>
													We're looking for people just like you to help build
													an army of followers to share in the profits of our
													program.
												</h4>
												<h4>
													Get Started Immediately and Receive All The
													Following...
												</h4>
												<ul>
													<li>
														<DoubleCheck
															style={{
																marginRight: '10px',
																height: '30px',
															}}
															color='#008000'
														/>
														<h5 className='d-inline text-danger yellow-highlight'>
															3 Ways to Earn
														</h5>{' '}
														Get paid for building your army of followers across
														the world.
													</li>
													<li>
														<DoubleCheck
															style={{
																marginRight: '10px',
																height: '30px',
															}}
															color='#008000'
														/>
														<h5 className='d-inline text-danger yellow-highlight'>
															Support
														</h5>{' '}
														Everything is setup for you and ready to go
													</li>
													<li>
														<DoubleCheck
															style={{
																marginRight: '10px',
																height: '30px',
															}}
															color='#008000'
														/>
														<h5 className='d-inline text-danger yellow-highlight'>
															Weekly Payouts
														</h5>{' '}
														Your commission is paid weekly direct into your bank
														account
													</li>
													<li>
														<DoubleCheck
															style={{
																marginRight: '10px',
																height: '30px',
															}}
															color='#008000'
														/>
														<h5 className='d-inline text-danger yellow-highlight'>
															No Skills Required
														</h5>{' '}
														No technical skills, no customers to talk to, no
														direct selling, anyone can get started.
													</li>
												</ul>
											</div>
											<div className='col-lg-6 video-box text-center'>
												<span
													className='play-btn mb-4 d-none'
													onClick={this.revealVideo}
												/>
											</div>
										</div>
									</div>
								</section>

								<section id='cta' className='cta'>
									<div className='container' data-aos='fade-in'>
										<div className='text-center'>
											<h3>Get Started Right Now</h3>
											<p>
												Signing up is so easy, just enter your first name and
												email address below and we'll send you a quick start
												email.
											</p>
											<Signup />
										</div>
									</div>
								</section>

								<div className='bg-dark text-muted p-2'>
									<div className='sales_page_section pb-5'>
										<div className='row'>
											<div className='col-12'>
												<p>
													<sup>*</sup>Earnings Disclaimer: Every effort has been
													made to accurately represent this product and it's
													potential. Even though this industry is one of the few
													where one can write their own check in terms of
													earnings, there is no guarantee that you will earn any
													money using the techniques and ideas in this product.
												</p>
												<p>
													<sup>*</sup>Examples in these materials are not to be
													taken as a promise or guarantee of earnings. Earning
													potential is entirely dependent on the person using
													our product, ideas, techniques and most importantly
													the effort put forth. We do not purport this as a "get
													rich scheme", and nor should you view it as such.
												</p>
											</div>
										</div>
									</div>
								</div>

								<footer id='footer' className='bg-primary'>
									<div className='footer-top'>
										<div className='container'>
											<div className='row'>
												<div className='col-lg-4 col-md-12 footer-info'>
													<h3>z5 Traffic</h3>
													<p>Online tools for affiliate & network marketers.</p>
												</div>

												<div className='col-lg-4 col-md-12 footer-links'>
													<h4>Useful Links</h4>
													<ul>
														<li>
															<a href='/'>Home</a>
														</li>
														<li className='d-none'>
															<a href='#'>About us</a>
														</li>
														<li className='d-none'>
															<a href='#'>Services</a>
														</li>
														<li>
															<a href='/terms'>Terms of service</a>
														</li>
														<li>
															<a href='/privacy'>Privacy policy</a>
														</li>
													</ul>
												</div>

												<div className='col-lg-4 col-md-12 footer-contact'>
													<h4>Contact Us</h4>
													<p>
														z5 Internet Ltd, registered in the UK (05294840)
														<br />
														<Link to='/contact'>
															<strong>Email us</strong>
														</Link>
													</p>

													<div className='social-links d-none'>
														<a href='#' className='twitter'>
															<i className='icofont-twitter'></i>
														</a>
														<a href='#' className='facebook'>
															<i className='icofont-facebook'></i>
														</a>
														<a href='#' className='instagram'>
															<i className='icofont-instagram'></i>
														</a>
														<a href='#' className='google-plus'>
															<i className='icofont-skype'></i>
														</a>
														<a href='#' className='linkedin'>
															<i className='icofont-linkedin'></i>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className='container'>
										<div className='copyright'>
											&copy; Copyright 2020-{new Date().getFullYear()}{' '}
											<strong>
												<span>z5 Traffic</span>
											</strong>{' '}
											z5 Internet Ltd. All Rights Reserved
										</div>
										<div className='credits'>
											Designed by{' '}
											<a href='https://bootstrapmade.com/'>BootstrapMade</a>
											<br />
											Icons made by{' '}
											<a
												href='https://www.flaticon.com/authors/freepik'
												title='Freepik'
											>
												Freepik
											</a>{' '}
											from{' '}
											<a href='https://www.flaticon.com/' title='Flaticon'>
												www.flaticon.com
											</a>
										</div>
									</div>
								</footer>
							</main>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(HomePage);
